import { toFixedExact } from '../../../core/services/utils/numbers';

/**  D.R.P. (Demonstração do Resultado do Pedido) */
export class DRP {
	/** Item */
	idItem: number;
	codigoIntegracaoErp: string;
	nome: string;
	quantidade: number;
	valorUnitario: number;
	percDesconto1: number;
	percDesconto2: number;
	valorLiquido: number;

  /*** 1. TOTAL BRUTO ***/
	valorTotalBruto: number;

	/** DVVs 1 = ICMS + PIS + COFINS + Frete + Perda e Devolução + Custo Financeiro + Desconto em Contrato **/
	// ICMS
	percAliquotaIcms: number;
	valorIcms: number;
	percIcmsComposicao: number;
	// PIS
	baseCalculoPis: number;
	percAliquotaPis: number;
	valorPis: number;
	percPisComposicao: number;
	// COFINS
	baseCalculoCofins: number;
	percAliquotaCofins: number;
	valorCofins: number;
	percCofinsComposicao: number;
	// Frete
	percDvvFrete: number;
	valorDvvFrete: number;
	percDvvFreteComposicao: number;
	// Perdas e Devoluções
	percPerdaDevolucao: number;
	valorPerdaDevolucao: number;
	percPerdaDevolucaoComposicao: number;
	// Custo Financeiro
	percCustoFinanceiro: number;
	valorCustoFinanceiro: number;
	percCustoFinanceiroComposicao: number;
	// Desconto em Contrato
	percDescontoContrato: number;
	valorDescontoContrato: number;
	percDescontoContratoComposicao: number;
	// Total DVV's 1
	percDvvs1: number;
	valorDvvs1: number;

	// Royalties
	percRoyalties: number;
	valorRoyalties: number;
	percRoyaltiesComposicao: number;
	// IPI
	ipiIsento: boolean;
	percAliquotaIpi: number;
	valorIpi: number;
	percIpiComposicao: number;
	// Comissão
	percComissao: number;
	valorComissao: number;
	percComissaoComposicao: number;

	/*** 2. (-) DVV's (DVV's 1 + Royalties + IPI + Comissão) ***/
	percDvvs: number;
	valorDvvs: number;
	percDvvsComposicao: number;

	/*** 3. (=) TOTAL LÍQUIDO ***/
	valorTotalLiquido: number;
	percTotalLiquidoComposicao: number;

	/*** 4. CUSTO MATÉRIA PRIMA ***/
	custoVariavelUnitario: number;
	custoVariavelTotal: number;
	percCustoVariavel: number;
	percCustoVariavelComposicao: number;

	/*** 5. (=) MARGEM DE CONTRIBUIÇÃO **/
	// Margem de Contribuição
	valorMargemContribuicao: number;
	percMargemContribuicao: number;
	percMargemContribuicaoComposicao: number;

	/*** 5.1. (-) CUSTO DIRETO ***/
	custoFixoUnitario: number;
	custoFixoTotal: number;
	percCustoFixo: number;
	percCustoFixoComposicao: number;

	/** Custo Indireto = Marketing + ADM + Outros **/
	// Marketing
	percMarketing: number;
	valorMarketing: number;
	percMarketingComposicao: number;
	percMarketingParticipacao: number;
	// Despesas Administrativas
	percDespesaAdministrativa: number;
	valorDespesaAdministrativa: number;
	percDespesaAdministrativaComposicao: number;
	percDespesaAdministrativaParticipacao: number;
	// Outros
	percOutros: number;
	valorOutros: number;
	percOutrosComposicao: number;
	percOutrosParticipacao: number;

	/*** 5.2. (-) CUSTO INDIRETO (Marketing + Despesas Administrativas + Outros) ***/
	percCustoIndireto: number;
	valorCustoIndireto: number;
	percCustoIndiretoParticipacao: number;
	percCustoIndiretoComposicao: number;

	/*** 6. (=) RESULTADO LÍQUIDO ***/
	valorResultadoLiquidoTotal: number;
	percResultadoLiquidoTotal: number;
	percResultadoLiquidoTotalComposicao: number;

	/*** 7. (-) IR/CSLL ***/
	// IR (Imposto de Renda)
	percIr: number;
	valorIr: number;
	percIrComposicao: number;
	percIrParticipacao: number;
	// CSLL (Contribuição Social)
	percContribuicaoSocial: number;
	valorContribuicaoSocial: number;
	percContribuicaoSocialComposicao: number;
	percContribuicaoSocialParticipacao: number;
	// IR (Imposto de Renda) + CSLL (Contribuição Social)
	percIrContribuicaoSocial: number;
	valorIrContribuicaoSocial: number;
	percIrContribuicaoSocialParticipacao: number;
	percIrContribuicaoSocialComposicao: number;

	/*** 8. (=) LUCRO LÍQUIDO ***/
	// Lucro Líquido
	valorLucroLiquido: number;
	percLucroLiquido: number;
	percLucroLiquidoMinimo: number;
	percLucroLiquidoComposicao: number;
	percLucroLiquidoAbaixo: boolean;

	/*** 9. QUALIDADE DE VALOR (QV) ***/
	// Grupo de Rentabilidade
	idGrupoRentabilidade: number;
	nomeGrupoRentabilidade: string;
	escalaGrupoRentabilidade: number;
	escalaSimboloGrupoRentabilidade: string;

	/* Calcula o Valor do ICMS sobre o valor total bruto */
	calcularValorIcms() {
		let valorIcms = (this.valorTotalBruto * this.percAliquotaIcms) / 100;
		valorIcms = toFixedExact(valorIcms, 4);
		this.valorIcms = valorIcms;
	}

	/* Calcula o percentual do ICMS sobre o valor bruto */
	calcularPercAliquotaIcms() {
		if (this.valorTotalBruto == 0) {
			this.percAliquotaIcms = 0;
			return;
		}
		let percAliquotaIcms = (this.valorIcms / this.valorTotalBruto) * 100;
		percAliquotaIcms = toFixedExact(percAliquotaIcms, 2);
		this.percAliquotaIcms = percAliquotaIcms;
	}

	/** Calcula a base de cálculo do PIS */
	calcularBaseCalculoPis() {
		// A base de cálculo do PIS é igual ao valor total bruto (valor da venda) - ICMS
		let baseCalculoPis = this.valorTotalBruto - this.valorIcms;
		baseCalculoPis = toFixedExact(baseCalculoPis, 2);
		this.baseCalculoPis = baseCalculoPis;
	}

	/* Calcula o Valor do PIS sobre o valor total bruto */
	calcularValorPis() {
		let valorPis = (this.baseCalculoPis * this.percAliquotaPis) / 100;
		valorPis = toFixedExact(valorPis, 4);
		this.valorPis = valorPis;
	}

	/* calcula o percentual do PIS sobre o valor bruto */
	calcularPercAliquotaPis() {
		if (this.baseCalculoPis == 0) {
			this.percAliquotaPis = 0;
			return;
		}
		let percAliquotaPis = (this.valorPis / this.baseCalculoPis) * 100;
		percAliquotaPis = toFixedExact(percAliquotaPis, 2);
		this.percAliquotaPis = percAliquotaPis;
	}

	/* Calcula o percentual de composição do PIS sobre o valor total bruto. Difere da alíquota, que incide sobre o valor bruto menos o ICMS */
	calcularPercPisComposicao() {
		if (this.valorTotalBruto == 0) {
			this.percPisComposicao = 0;
			return;
		}
		let percPisComposicao = (this.valorPis / this.valorTotalBruto) * 100;
		percPisComposicao = toFixedExact(percPisComposicao, 2);
		this.percPisComposicao = percPisComposicao;
	}

	/** Calcula a base de cálculo do COFINS */
	calcularBaseCalculoCofins() {
		// A base de cálculo do COFINS é igual ao valor total bruto (valor da venda) - ICMS
		let baseCalculoCofins = this.valorTotalBruto - this.valorIcms;
		baseCalculoCofins = toFixedExact(baseCalculoCofins, 2);
		this.baseCalculoCofins = baseCalculoCofins;
	}

	/* Calcula o Valor do COFINS sobre o valor total bruto */
	calcularValorCofins() {
		let valorCofins = (this.baseCalculoCofins * this.percAliquotaCofins) / 100;
		valorCofins = toFixedExact(valorCofins, 4);
		this.valorCofins = valorCofins;
	}

	/* Calcula o percentual do COFINS sobre o valor bruto */
	calcularPercAliquotaCofins() {
		if (this.baseCalculoCofins == 0) {
			this.percAliquotaCofins = 0;
			return;
		}
		let percAliquotaCofins = (this.valorCofins / this.baseCalculoCofins) * 100;
		percAliquotaCofins = toFixedExact(percAliquotaCofins, 2);
		this.percAliquotaCofins = percAliquotaCofins;
	}

	/* Calcula o percentual de composição do COFINS sobre o valor total bruto. Difere da alíquota, que incide sobre o valor bruto menos o ICMS */
	calcularPercCofinsComposicao() {
		if (this.valorTotalBruto == 0) {
			this.percCofinsComposicao = 0;
			return;
		}
		let percCofinsComposicao = (this.valorCofins / this.valorTotalBruto) * 100;
		percCofinsComposicao = toFixedExact(percCofinsComposicao, 2);
		this.percCofinsComposicao = percCofinsComposicao;
	}

	/* Calcula o Valor do Frete sobre o valor total bruto */
	calcularValorDvvFrete() {
		let valorFrete = (this.valorTotalBruto * this.percDvvFrete) / 100;
		valorFrete = toFixedExact(valorFrete, 4);
		this.valorDvvFrete = valorFrete;
	}

	/* Calcula o percentual do frete sobre o valor bruto */
	calcularPercDvvFrete() {
		if (this.valorTotalBruto == 0) {
			this.percDvvFrete = 0;
			return;
		}
		let percDvvFrete = (this.valorDvvFrete / this.valorTotalBruto) * 100;
		percDvvFrete = toFixedExact(percDvvFrete, 2);
		this.percDvvFrete = percDvvFrete;
	}

	/* Calcula o valor das DVV's 1 somando os valores de ICMS + PIS + COFINS + Frete + Perda e Devolução + Custo Financeiro + Desconto em Contrato */
	somarValorDvvs1() {
		let valorDvvs1 = this.valorIcms + this.valorPis + this.valorCofins + this.valorDvvFrete
			+ this.valorPerdaDevolucao + this.valorCustoFinanceiro + this.valorDescontoContrato;
		valorDvvs1 = toFixedExact(valorDvvs1, 4);
		this.valorDvvs1 = valorDvvs1;
	}

	/* Calcula o valor percentual das DVV's 1 sobre o valor total bruto */
	calcularPercDvvs1() {
		if (this.valorTotalBruto == 0) {
			this.percDvvs1 = 0;
			return;
		}
		let percDvvs1 = (this.valorDvvs1 / this.valorTotalBruto) * 100;
		percDvvs1 = toFixedExact(percDvvs1, 2);
		this.percDvvs1 = percDvvs1;
	}

	/* Calcula o valor das perdas e devoluções sobre o valor total bruto */
	calcularValorPerdaDevolucao() {
		let valorPerdaDevolucao = (this.valorTotalBruto * this.percPerdaDevolucao) / 100;
		valorPerdaDevolucao = toFixedExact(valorPerdaDevolucao, 4);
		this.valorPerdaDevolucao = valorPerdaDevolucao;
	}

	/* Calcula o percentual das perdas e devoluções sobre o valor bruto */
	calcularPercPerdaDevolucao() {
		if (this.valorTotalBruto == 0) {
			this.percPerdaDevolucao = 0;
			return;
		}
		let percPerdaDevolucao = (this.valorPerdaDevolucao / this.valorTotalBruto) * 100;
		percPerdaDevolucao = toFixedExact(percPerdaDevolucao, 2);
		this.percPerdaDevolucao = percPerdaDevolucao;
	}

	/* Calcula o valor do custo financeiro sobre o valor total bruto */
	calcularValorCustoFinanceiro() {
		let valorCustoFinanceiro = (this.valorTotalBruto * this.percCustoFinanceiro) / 100;
		valorCustoFinanceiro = toFixedExact(valorCustoFinanceiro, 4);
		this.valorCustoFinanceiro = valorCustoFinanceiro;
	}

	/* Calcula o percentual do custo financeiro sobre o valor bruto */
	calcularPercCustoFinanceiro() {
		if (this.valorTotalBruto == 0) {
			this.percCustoFinanceiro = 0;
			return;
		}
		let percCustoFinanceiro = (this.valorCustoFinanceiro / this.valorTotalBruto) * 100;
		percCustoFinanceiro = toFixedExact(percCustoFinanceiro, 2);
		this.percCustoFinanceiro = percCustoFinanceiro;
	}

	/* Calcula o valor do desconto em contrato sobre o valor total bruto */
	calcularValorDescontoContrato() {
		let valorDescontoContrato = (this.valorTotalBruto * this.percDescontoContrato) / 100;
		valorDescontoContrato = toFixedExact(valorDescontoContrato, 4);
		this.valorDescontoContrato = valorDescontoContrato;
	}

	/* Calcula o percentual do desconto em contrato sobre o valor bruto */
	calcularPercDescontoContrato() {
		if (this.valorTotalBruto == 0) {
			this.percDescontoContrato = 0;
			return;
		}
		let percDescontoContrato = (this.valorDescontoContrato / this.valorTotalBruto) * 100;
		percDescontoContrato = toFixedExact(percDescontoContrato, 2);
		this.percDescontoContrato = percDescontoContrato;
	}

	/* Calcula o valor dos royalties sobre o valor total bruto */
	calcularValorRoyalties() {
		let valorRoyalties = (this.valorTotalBruto * this.percRoyalties) / 100;
		valorRoyalties = toFixedExact(valorRoyalties, 4);
		this.valorRoyalties = valorRoyalties;
	}

	/* Calcula o percentual dos royalties sobre o valor bruto */
	calcularPercRoyalties() {
		if (this.valorTotalBruto == 0) {
			this.percRoyalties = 0;
			return;
		}
		let percRoyalties = (this.valorRoyalties / this.valorTotalBruto) * 100;
		percRoyalties = toFixedExact(percRoyalties, 2);
		this.percRoyalties = percRoyalties;
	}

	/* Calcula o valor do IPI sobre o valor total bruto */
	calcularValorIpi() {
		let valorIpi = (this.valorTotalBruto * this.percAliquotaIpi) / 100;
		valorIpi = toFixedExact(valorIpi, 4);
		this.valorIpi = valorIpi;
	}

	/* Calcula o percentual do IPI sobre o valor bruto */
	calcularPercAliquotaIpi() {
		if (this.valorTotalBruto == 0) {
			this.percAliquotaIpi = 0;
			return;
		}
		let percAliquotaIpi = (this.valorIpi / this.valorTotalBruto) * 100;
		percAliquotaIpi = toFixedExact(percAliquotaIpi, 2);
		this.percAliquotaIpi = percAliquotaIpi;
	}

	/* Calcula o valor da comissão sobre o valor total bruto */
	calcularValorComissao() {
		let valorComissao = (this.valorTotalBruto * this.percComissao) / 100;
		valorComissao = toFixedExact(valorComissao, 4);
		this.valorComissao = valorComissao;
	}

	/* Calcula o percentual da comissão sobre o valor bruto */
	calcularPercComissao() {
		if (this.valorTotalBruto == 0) {
			this.percComissao = 0;
			return;
		}
		let percComissao = (this.valorComissao / this.valorTotalBruto) * 100;
		percComissao = toFixedExact(percComissao, 2);
		this.percComissao = percComissao;
	}

	/*** 2. (-) DVV's (DVV's 1 + Royalties + IPI + Comissão) ***/

	/* Calcula o percentual das DVV's somando os percentuais das DVV's 1 + Royalties + IPI + Comissão */
	somarPercDvvs() {
		let percDvvs = this.percDvvs1 + this.percRoyalties + this.percAliquotaIpi + this.percComissao;
		percDvvs = toFixedExact(percDvvs, 2);
		this.percDvvs = percDvvs;
	}

	/* Calcula o valor das DVV's somando os valores das DVV's 1 + Royalties + IPI + Comissão */
	somarValorDvvs() {
		let valorDvvs = this.valorDvvs1 + this.valorRoyalties + this.valorIpi + this.valorComissao;
		valorDvvs = toFixedExact(valorDvvs, 4);
		this.valorDvvs = valorDvvs;
	}

	/* Calcula o percentual de composição das DVV's sobre o valor total bruto */
	calcularPercDvvsComposicao() {
		if (this.valorTotalBruto == 0) {
			this.percDvvsComposicao = 0;
			return;
		}
		let percDvvsComposicao = (this.valorDvvs / this.valorTotalBruto) * 100;
		percDvvsComposicao = toFixedExact(percDvvsComposicao, 2)
		this.percDvvsComposicao = percDvvsComposicao;
	}

	/*** 3. (=) TOTAL LÍQUIDO ***/
	/* Calcula o valor total líquido subtraindo o valor total bruto pelo valor das DVV's (DVV's 1 + Royalties + IPI + Comissão) */
	calcularValorTotalLiquido() {
		let valorTotalLiquido = this.valorTotalBruto - this.valorDvvs;
		valorTotalLiquido = toFixedExact(valorTotalLiquido, 4);
		this.valorTotalLiquido = valorTotalLiquido;
	}

	/*** 4. CUSTO MATÉRIA PRIMA ***/
	/* Calcula o valor total do custo variável (Matéria Prima) múltiplicando o custo unitário pela quantidade */
	calcularCustoVariavelTotal(quantidade: number) {
		let custoVariavelTotal = quantidade * this.custoVariavelUnitario;
		custoVariavelTotal = toFixedExact(custoVariavelTotal, 4);
		this.custoVariavelTotal = custoVariavelTotal;
	}

	/* Calcula o percentual do custo variável dividindo o valor total do custo variavel pelo valor total líquido */
	calcularPercCustoVariavel() {
		if (this.valorTotalLiquido <= 0) {
			this.percCustoVariavel = 0;
			return;
		}
		let percCustoVariavel = (this.custoVariavelTotal / this.valorTotalLiquido) * 100;
		percCustoVariavel = toFixedExact(percCustoVariavel, 2);
		this.percCustoVariavel = percCustoVariavel;
	}

	/* Calcula o percentual de composição do custo variável (Matéria Prima) sobre o valor total bruto */
	calcularPercCustoVariavelComposicao() {
		if (this.valorTotalBruto == 0) {
			this.percCustoVariavelComposicao = 0;
			return;
		}
		let percCustoVariavelComposicao = (this.custoVariavelTotal / this.valorTotalBruto) * 100;
		percCustoVariavelComposicao = toFixedExact(percCustoVariavelComposicao, 2);
		this.percCustoVariavelComposicao = percCustoVariavelComposicao;
	}

	/*** 5. (=) MARGEM DE CONTRIBUIÇÃO **/
	/* Calcula o valor da margem de contribuição subtraindo o valor total líquido pelo valor total do custo variável (matéria prima) */
	calcularValorMargemContribuicao() {
		let valorMargemContribuicao = this.valorTotalLiquido - this.custoVariavelTotal;
		valorMargemContribuicao = toFixedExact(valorMargemContribuicao, 4);
		this.valorMargemContribuicao = valorMargemContribuicao;
	}

	/* Calcula o percentual da margem de contribuição sobre o valor total líquido */
	calcularPercMargemContribuicao() {
		if (this.valorTotalLiquido <= 0) {
			this.percMargemContribuicao = 0;
			return;
		}
		let percMargemContribuicao = (this.valorMargemContribuicao / this.valorTotalLiquido) * 100;
		percMargemContribuicao = toFixedExact(percMargemContribuicao, 2);
		this.percMargemContribuicao = percMargemContribuicao;
	}

	/* Calcula o percentual de composição da margem de contribuição sobre o valor total bruto */
	calcularPercMargemContribuicaoComposicao() {
		if (this.valorTotalBruto == 0) {
			this.percMargemContribuicaoComposicao = 0;
			return;
		}
		let percMargemContribuicaoComposicao = (this.valorMargemContribuicao / this.valorTotalBruto) * 100;
		percMargemContribuicaoComposicao = toFixedExact(percMargemContribuicaoComposicao, 2);
		this.percMargemContribuicaoComposicao = percMargemContribuicaoComposicao;
	}

	/*** 5.1. (-) CUSTO DIRETO ***/
	/* Calcula o valor total do custo fixo múltiplicando o custo unitário pela quantidade */
	calcularCustoFixoTotal(quantidade: number) {
		let custoFixoTotal = quantidade * this.custoFixoUnitario;
		custoFixoTotal = toFixedExact(custoFixoTotal, 4);
		this.custoFixoTotal = custoFixoTotal;
	}

	/* Calcula o percentual do custo fixo dividindo o valor total do custo fixo pelo valor total líquido */
	calcularPercCustoFixo() {
		if (this.valorTotalLiquido <= 0) {
			this.percCustoFixo = 0;
			return;
		}
		let percCustoFixo = (this.custoFixoTotal / this.valorTotalLiquido) * 100;
		percCustoFixo = toFixedExact(percCustoFixo, 2);
		this.percCustoFixo = percCustoFixo;
	}

	/* Calcula o percentual de composição do custo fixo sobre o valor total bruto */
	calcularPercCustoFixoComposicao() {
		if (this.valorTotalBruto == 0) {
			this.percCustoFixoComposicao = 0;
			return;
		}
		let percCustoFixoComposicao = (this.custoFixoTotal / this.valorTotalBruto) * 100;
		percCustoFixoComposicao = toFixedExact(percCustoFixoComposicao, 2);
		this.percCustoFixoComposicao = percCustoFixoComposicao;
	}

	/** Custo Indireto = Marketing + ADM + Outros **/

	/* Calcula o valor do marketing sobre o valor total bruto */
	calcularValorMarketing() {
		let valorMarketing = (this.valorTotalBruto * this.percMarketing) / 100;
		valorMarketing = toFixedExact(valorMarketing, 4);
		this.valorMarketing = valorMarketing;
	}

	/* Calcula o percentual do marketing sobre o valor bruto */
	calcularPercMarketing() {
		if (this.valorTotalBruto == 0) {
			this.percMarketing = 0;
			return;
		}
		let percMarketing = (this.valorMarketing / this.valorTotalBruto) * 100;
		percMarketing = toFixedExact(percMarketing, 2);
		this.percMarketing = percMarketing;
	}

	/* Calcula o percentual de participação do marketing sobre o valor total líquido */
	calcularPercMarketingParticipacao() {
		if (this.valorTotalLiquido <= 0) {
			this.percMarketingParticipacao = 0;
			return;
		}
		let percMarketingParticipacao = (this.valorMarketing / this.valorTotalLiquido) * 100;
		percMarketingParticipacao = toFixedExact(percMarketingParticipacao, 2);
		this.percMarketingParticipacao = percMarketingParticipacao;
	}

	/* Calcula o valor das despesas administrativas sobre o valor total bruto */
	calcularValorDespesaAdministrativa() {
		let valorDespesaAdministrativa = (this.valorTotalBruto * this.percDespesaAdministrativa) / 100;
		valorDespesaAdministrativa = toFixedExact(valorDespesaAdministrativa, 4);
		this.valorDespesaAdministrativa = valorDespesaAdministrativa;
	}

	/* Calcula o percentual das depesas adminitrativas sobre o valor bruto */
	calcularPercDespesaAdministrativa() {
		if (this.valorTotalBruto == 0) {
			this.percDespesaAdministrativa = 0;
			return;
		}
		let percDespesaAdministrativa = (this.valorDespesaAdministrativa / this.valorTotalBruto) * 100;
		percDespesaAdministrativa = toFixedExact(percDespesaAdministrativa, 2);
		this.percDespesaAdministrativa = percDespesaAdministrativa;
	}

	/* Calcula o percentual de participação das despesas administrativas sobre o valor total líquido */
	calcularPercDespesaAdministrativaParticipacao() {
		if (this.valorTotalLiquido <= 0) {
			this.percDespesaAdministrativaParticipacao = 0;
			return;
		}
		let percDespesaAdministrativaParticipacao = (this.valorDespesaAdministrativa / this.valorTotalLiquido) * 100;
		percDespesaAdministrativaParticipacao = toFixedExact(percDespesaAdministrativaParticipacao, 2);
		this.percDespesaAdministrativaParticipacao = percDespesaAdministrativaParticipacao;
	}

	/* Calcula o valor de outros sobre o valor total bruto */
	calcularValorOutros() {
		let valorOutros = (this.valorTotalBruto * this.percOutros) / 100;
		valorOutros = toFixedExact(valorOutros, 4);
		this.valorOutros = valorOutros;
	}

	/* Calcula o percentual de outros sobre o valor bruto */
	calcularPercOutros() {
		if (this.valorTotalBruto == 0) {
			this.percOutros = 0;
			return;
		}
		let percOutros = (this.valorOutros / this.valorTotalBruto) * 100;
		percOutros = toFixedExact(percOutros, 2);
		this.percOutros = percOutros;
	}

	/* Calcula o percentual de participação de outros sobre o valor total líquido */
	calcularPercOutrosParticipacao() {
		if (this.valorTotalLiquido <= 0) {
			this.percOutrosParticipacao = 0;
			return;
		}
		let percOutrosParticipacao = (this.valorOutros / this.valorTotalLiquido) * 100;
		percOutrosParticipacao = toFixedExact(percOutrosParticipacao, 2);
		this.percOutrosParticipacao = percOutrosParticipacao;
	}

	/*** 5.2. (-) CUSTO INDIRETO (Marketing + Despesas Administrativas + Outros) ***/
	/* Calcula o percentual do custo indireto somando os percentuais de Marketing + Despesas Administrativas + Outros */
	somarPercCustoIndireto() {
		let percCustoIndireto = this.percMarketing + this.percDespesaAdministrativa + this.percOutros;
		percCustoIndireto = toFixedExact(percCustoIndireto, 2);
		this.percCustoIndireto = percCustoIndireto;
	}

	/* Calcula o valor do custo indireto somando os valores de Marketing + Despesas Administrativas + Outros */
	somarValorCustoIndireto() {
		let valorCustoIndireto = this.valorMarketing + this.valorDespesaAdministrativa + this.valorOutros;
		valorCustoIndireto = toFixedExact(valorCustoIndireto, 4);
		this.valorCustoIndireto = valorCustoIndireto;
	}

	/* Calcula o percentual de participação do custo indireto sobre o valor total líquido */
	calcularPercCustoIndiretoParticipacao() {
		if (this.valorTotalLiquido <= 0) {
			this.percCustoIndiretoParticipacao = 0;
			return;
		}
		let percCustoIndiretoParticipacao = (this.valorCustoIndireto / this.valorTotalLiquido) * 100;
		percCustoIndiretoParticipacao = toFixedExact(percCustoIndiretoParticipacao, 2);
		this.percCustoIndiretoParticipacao = percCustoIndiretoParticipacao;
	}

	/* Calcula o percentual de composição do custo indireto sobre o valor total bruto */
	calcularPercCustoIndiretoComposicao() {
		if (this.valorTotalBruto == 0) {
			this.percCustoIndiretoComposicao = 0;
			return;
		}
		let percCustoIndiretoComposicao = (this.valorCustoIndireto / this.valorTotalBruto) * 100;
		percCustoIndiretoComposicao = toFixedExact(percCustoIndiretoComposicao, 2);
		this.percCustoIndiretoComposicao = percCustoIndiretoComposicao;
	}

	/*** 6. (=) RESULTADO LÍQUIDO ***/
	/* Calcular o valor do resultado líquido subtraindo o valor da margem de contribuição pelos valores dos custos diretos e indiretos */
	calcularValorResultadoLiquidoTotal() {
		let valorResultadoLiquidoTotal = this.valorMargemContribuicao - this.custoFixoTotal - this.valorCustoIndireto;
		valorResultadoLiquidoTotal = toFixedExact(valorResultadoLiquidoTotal, 4);
		this.valorResultadoLiquidoTotal = valorResultadoLiquidoTotal;
	}

	/* Calcula o percentual de participação do resultado líquido sobre o valor total líquido */
	calcularPercResultadoLiquidoTotal() {
		if (this.valorTotalLiquido <= 0) {
			this.percResultadoLiquidoTotal = 0;
			return;
		}
		let percResultadoLiquidoTotal = (this.valorResultadoLiquidoTotal / this.valorTotalLiquido) * 100;
		percResultadoLiquidoTotal = toFixedExact(percResultadoLiquidoTotal, 2);
		this.percResultadoLiquidoTotal = percResultadoLiquidoTotal;
	}

	/* Calcula o percentual de composição do resultado líquido sobre o valor total bruto */
	calcularPercResultadoLiquidoTotalComposicao() {
		if (this.valorTotalBruto == 0) {
			this.percResultadoLiquidoTotalComposicao = 0;
			return;
		}
		let percResultadoLiquidoTotalComposicao = (this.valorResultadoLiquidoTotal / this.valorTotalBruto) * 100;
		percResultadoLiquidoTotalComposicao = toFixedExact(percResultadoLiquidoTotalComposicao, 2);
		this.percResultadoLiquidoTotalComposicao = percResultadoLiquidoTotalComposicao;
	}

	/*** 7. (-) IR/CSLL ***/
	/* Calcula o valor do IR (Imposto de Renda) sobre o valor do resultado líquido */
	calcularValorIr() {
		let valorIr: number;
		if (this.valorResultadoLiquidoTotal < 0) { // Se o resultado líquido for negativo, então não há IR
			valorIr = 0;
		} else {
			valorIr = (this.valorResultadoLiquidoTotal * this.percIr) / 100;
		}

		valorIr = toFixedExact(valorIr, 4);
		this.valorIr = valorIr;
	}

	/* Calcula o percentual do IR sobre o valor bruto */
	calcularPercIr() {
		if (this.valorResultadoLiquidoTotal == 0) {
			this.percIr = 0;
			return;
		}
		let percIr = (this.valorIr / this.valorResultadoLiquidoTotal) * 100;
		percIr = toFixedExact(percIr, 2);
		this.percIr = percIr;
	}

	/* Calcula o percentual de participação do IR sobre o valor total líquido */
	calcularPercIrParticipacao() {
		if (this.valorTotalLiquido <= 0) {
			this.percIrParticipacao = 0;
			return;
		}
		let percIrParticipacao = (this.valorIr / this.valorTotalLiquido) * 100;
		percIrParticipacao = toFixedExact(percIrParticipacao, 2);
		this.percIrParticipacao = percIrParticipacao;
	}

	/* Calcula o valor do CSLL (Contribuição Social) sobre o valor do resultado líquido */
	calcularValorContribuicaoSocial() {
		let valorContribuicaoSocial: number;
		if (this.valorResultadoLiquidoTotal < 0) { // Se o resultado líquido for negativo, então não há CSLL
			valorContribuicaoSocial = 0;
		} else {
			valorContribuicaoSocial = (this.valorResultadoLiquidoTotal * this.percContribuicaoSocial) / 100;
		}

		valorContribuicaoSocial = toFixedExact(valorContribuicaoSocial, 4);
		this.valorContribuicaoSocial = valorContribuicaoSocial;
	}

	/* Calcula o percentual do CSLL sobre o valor bruto */
	calcularPercContribuicaoSocial() {
		if (this.valorResultadoLiquidoTotal == 0) {
			this.percContribuicaoSocial = 0;
			return;
		}
		let percContribuicaoSocial = (this.valorContribuicaoSocial / this.valorResultadoLiquidoTotal) * 100;
		percContribuicaoSocial = toFixedExact(percContribuicaoSocial, 2);
		this.percContribuicaoSocial = percContribuicaoSocial;
	}

	/* Calcula o percentual de participação do CSLL sobre o valor total líquido */
	calcularPercContribuicaoSocialParticipacao() {
		if (this.valorTotalLiquido <= 0) {
			this.percContribuicaoSocialParticipacao = 0;
			return;
		}
		let percContribuicaoSocialParticipacao = (this.valorContribuicaoSocial / this.valorTotalLiquido) * 100;
		percContribuicaoSocialParticipacao = toFixedExact(percContribuicaoSocialParticipacao, 2);
		this.percContribuicaoSocialParticipacao = percContribuicaoSocialParticipacao;
	}

	/* Calcula o percentual total do IR + CSLL */
	somarPercIrContribuicaoSocial() {
		let percIrContribuicaoSocial = this.percIr + this.percContribuicaoSocial;
		percIrContribuicaoSocial = toFixedExact(percIrContribuicaoSocial, 2);
		this.percIrContribuicaoSocial = percIrContribuicaoSocial;
	}

	/* Calcula o valor total do IR + CSLL */
	somarValorIrContribuicaoSocial() {
		let valorIrContribuicaoSocial = this.valorIr + this.valorContribuicaoSocial;
		valorIrContribuicaoSocial = toFixedExact(valorIrContribuicaoSocial, 4);
		this.valorIrContribuicaoSocial = valorIrContribuicaoSocial;
	}

	/* Calcula o percentual de participação do IR + CSLL sobre o valor total líquido */
	calcularPercIrContribuicaoSocialParticipacao() {
		if (this.valorTotalLiquido <= 0) {
			this.percIrContribuicaoSocialParticipacao = 0;
			return;
		}
		let percIrContribuicaoSocialParticipacao = (this.valorIrContribuicaoSocial / this.valorTotalLiquido) * 100;
		percIrContribuicaoSocialParticipacao = toFixedExact(percIrContribuicaoSocialParticipacao, 2);
		this.percIrContribuicaoSocialParticipacao = percIrContribuicaoSocialParticipacao;
	}

	/* Calcula o percentual de composição do IR + CSLL sobre o valor total bruto */
	calcularPercIrContribuicaoSocialComposicao() {
		if (this.valorTotalBruto == 0) {
			this.percIrContribuicaoSocialComposicao = 0;
			return;
		}
		let percIrContribuicaoSocialComposicao = (this.valorIrContribuicaoSocial / this.valorTotalBruto) * 100;
		percIrContribuicaoSocialComposicao = toFixedExact(percIrContribuicaoSocialComposicao, 2);
		this.percIrContribuicaoSocialComposicao = percIrContribuicaoSocialComposicao;
	}

	/*** 8. (=) LUCRO LÍQUIDO ***/
	/* Calcula o valor do lucro líquido subtraindo o valor do resultado líquido pelo IR + CSLL */
	calcularValorLucroLiquido() {
		let valorLucroLiquido = this.valorResultadoLiquidoTotal - this.valorIrContribuicaoSocial;
		valorLucroLiquido = toFixedExact(valorLucroLiquido, 4);
		this.valorLucroLiquido = valorLucroLiquido;
	}

	/* Calcula a margem de lucro: percentual de participação do lucro líquido sobre o valor total líquido */
	calcularPercLucroLiquido() {
		if (this.valorTotalLiquido <= 0) {
			this.percLucroLiquido = 0;
			return;
		}
		let percLucroLiquido = (this.valorLucroLiquido / this.valorTotalLiquido) * 100;
		percLucroLiquido = toFixedExact(percLucroLiquido, 2);
		this.percLucroLiquido = percLucroLiquido;
	}

	/* Calcula o percentual de composição do lucro líquido sobre o valor total bruto */
	calcularPercLucroLiquidoComposicao() {
		if (this.valorTotalBruto == 0) {
			this.percLucroLiquidoComposicao = 0;
			return;
		}
		let percLucroLiquidoComposicao = (this.valorLucroLiquido / this.valorTotalBruto) * 100;
		percLucroLiquidoComposicao = toFixedExact(percLucroLiquidoComposicao, 2);
		this.percLucroLiquidoComposicao = percLucroLiquidoComposicao;
	}

	/** Composições derivadas **/

	/**
	 * Preenche as composições que o back deriva na leitura: cada uma é o valor da linha sobre o valor
	 * total bruto. Roda ao final da apuração, quando todos os valores já existem.
	 */
	calcularComposicoesDerivadas() {
		this.percIcmsComposicao = this.composicaoSobreBruto(this.valorIcms);
		this.percDvvFreteComposicao = this.composicaoSobreBruto(this.valorDvvFrete);
		this.percPerdaDevolucaoComposicao = this.composicaoSobreBruto(this.valorPerdaDevolucao);
		this.percCustoFinanceiroComposicao = this.composicaoSobreBruto(this.valorCustoFinanceiro);
		this.percDescontoContratoComposicao = this.composicaoSobreBruto(this.valorDescontoContrato);
		this.percRoyaltiesComposicao = this.composicaoSobreBruto(this.valorRoyalties);
		this.percIpiComposicao = this.composicaoSobreBruto(this.valorIpi);
		this.percComissaoComposicao = this.composicaoSobreBruto(this.valorComissao);
		this.percMarketingComposicao = this.composicaoSobreBruto(this.valorMarketing);
		this.percDespesaAdministrativaComposicao = this.composicaoSobreBruto(this.valorDespesaAdministrativa);
		this.percOutrosComposicao = this.composicaoSobreBruto(this.valorOutros);
		this.percIrComposicao = this.composicaoSobreBruto(this.valorIr);
		this.percContribuicaoSocialComposicao = this.composicaoSobreBruto(this.valorContribuicaoSocial);
		this.percTotalLiquidoComposicao = this.composicaoSobreBruto(this.valorTotalLiquido);
	}

	/* Divide um valor do demonstrativo pelo valor total bruto */
	private composicaoSobreBruto(valor: number): number {
		if (this.valorTotalBruto == 0) {
			return 0;
		}
		return toFixedExact((valor / this.valorTotalBruto) * 100, 2);
	}
}
